import React from 'react';
import { Table } from 'react-bootstrap';
import { Totals } from '../../../../../../brand/campaign/book/offer/modal/tabs/offer/Totals';
import { getSubtotalOfferItems } from '../../../../../../../shared/functions/Functions';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../store/rootReducer';
import { InitialContractPlatform } from './InitialContractPlatform';
import { TotalTypes } from '../../../../../../../enum/TotalTypes';

export function InfluencerContractPlatformTable() {
    const { t } = useTranslation();
    const { initialContract, campaign, isCharity } = useSelector((state: IAllStates) => state.contractInfluencer);
    return (
        <>
            <div className="overflow-hidden table-offer-items">
                <Table className="table-head-bg m-0 mt-1">
                    <thead className="table-head-bg d-none d-md-table-row_group">
                        <tr>
                            <th>{t('brand.campaign.book.offer.modal.platform')}</th>
                            <th className="text-center">{t('brand.campaign.book.offer.modal.followers')}</th>
                            <th className="text-center">{t('brand.campaign.book.offer.modal.avg_reach')}</th>
                            <th className="text-center">{t('brand.campaign.book.offer.modal.audience_per_country')}</th>
                            <th className={`${isCharity ? 'd-none' : 'text-center'}`}>
                                {t('brand.campaign.book.offer.modal.cpm')}
                            </th>
                            <th className={`${isCharity ? 'd-none' : 'text-end'}`} style={{ width: 150 }}>
                                {t('brand.campaign.book.offer.modal.price')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {campaign?.contractPlaceholder?.totalPlatforms?.map((platform, index) => (
                            <InitialContractPlatform key={index} platform={platform} />
                        ))}
                    </tbody>
                </Table>
            </div>
            {!isCharity && (
                <div className="w-100 mt-2">
                    <Totals
                        title={TotalTypes.OFFER_ITEMS}
                        price={getSubtotalOfferItems(initialContract?.contractItems)}
                    />
                </div>
            )}
        </>
    );
}
